import TripPackageSet from '../TripPackageSet';
import type FlightPackage from './FlightPackage';
import { type FlightsMetaDto } from '@clients/FlightApi';
import { type FlightFilters } from '@itinerary/trip/flight/FlightModuleTypes';
import { FlightPackageLoader } from '@itinerary/trip/flight/FlightPackageLoader';
import { type FlightPackageLoaderConfig } from '@itinerary/trip/flight/types';

/**
 * Stores data related to a list of packages, that one of them must be chosen
 */
export default class FlightPackageSet extends TripPackageSet<
    FlightsMetaDto,
    FlightFilters,
    FlightPackage
> {
    override loader: FlightPackageLoader;

    get adultCount() {
        return this.loader.adultCount;
    }

    get childCount() {
        return this.loader.childCount;
    }

    get infantCount() {
        return this.loader.infantCount;
    }

    get isHigherCapacityLoaded() {
        return this.loader.isHigherCapacityLoaded;
    }

    protected override reset(
        config: FlightPackageLoaderConfig,
        filters: Record<FlightFilters, any>
    ) {
        super.reset(config, filters);
        this.loader = new FlightPackageLoader(config);
    }

    override get isRouteEnabled() {
        if (this.loader.isForeign) {
            return false;
        }
        return super.isRouteEnabled;
    }

    constructor(
        config: FlightPackageLoaderConfig,
        /**
         * Contains filters that must be applied to the results
         */
        public override filters: Record<FlightFilters, any>
    ) {
        super(filters);
        this.loader = new FlightPackageLoader(config);
    }
}
